<template>
    <nav class="bg-light mb-3 navbar navbar-expand-md navbar-side-navbar">
        <div class="collapse navbar-collapse sidebar-navbar-collapse" id="navbarSupportedContent">
            <ul class="flex-column navbar-nav">
                <li class="nav-item">
                    <RouterLink :to="{name:'Home'}" class="nav-link">
                        <i aria-hidden="true" class="fa-home fas fa-fw"></i>Home
                    </RouterLink>
                </li>
                <li class="nav-item"
                    v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator,ApplicationRole.NetworkAdministrator,ApplicationRole.Facilities,ApplicationRole.Business,ApplicationRole.TTIWebsiteAdministrator)">
                    <RouterLink :to="{name:'Organizations'}" class="nav-link">
                        <i aria-hidden="true" class="fas fa-sitemap fa-fw"></i>Organizations
                    </RouterLink>
                </li>
                <li class="nav-item"
                    v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator,ApplicationRole.NetworkAdministrator,ApplicationRole.Facilities,ApplicationRole.Business,ApplicationRole.TTIWebsiteAdministrator)">
                    <RouterLink :to="{name:'People'}" class="nav-link">
                        <i aria-hidden="true" class="fas fa-user fa-fw"></i>People
                    </RouterLink>
                </li>
                <li class="nav-item"
                    v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator, ApplicationRole.NetworkAdministrator)">
                    <RouterLink :to="{name:'AzureBillingPeriods'}" class="nav-link">
                        <i aria-hidden="true" class="fas fa-fw fa-file-invoice-dollar"></i>Azure Billing
                    </RouterLink>
                </li>
                <li class="nav-item" v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator)">
                    <RouterLink :to="{name:'GeneralCodes'}" class="nav-link">
                        <i aria-hidden="true" class="fa-book fas fa-fw"></i>General Codes
                    </RouterLink>
                </li>
                <li class="nav-item"
                    v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator,ApplicationRole.HR)">
                    <RouterLink :to="{name:'AdministrativeLocations'}" class="nav-link">
                        <i aria-hidden="true" class="fa-map fas fa-fw"></i>Adlocs
                    </RouterLink>
                </li>
                <li class="nav-item"
                    v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator,ApplicationRole.Facilities)">
                    <a class="collapsed nav-link" data-target="#toggleFacilities" data-toggle="collapse"
                       href="javascript:void(0);">
                        <i class="fas fa-building"></i> Facilities
                        <span aria-hidden="true" class="fa fa-caret-down float-right"></span>
                    </a>
                    <div class="collapse" id="toggleFacilities" style="height: 0px;">
                        <RouterLink :to="{name:'Buildings'}" class="nav-link">
                            <i class="fas fa-fw"></i>Offices
                        </RouterLink>
                    </div>
                    <div class="collapse" id="toggleFacilities" style="height: 0px;">
                        <RouterLink :to="{name:'Keys'}" class="nav-link">
                            <i class="fas fa-fw"></i>Keys
                        </RouterLink>
                    </div>
                </li>
                <li class="nav-item"
                    v-if="hasApplicationRole(ApplicationRole.Business) && !hideFinancialServicesFeature">
                    <a class="collapsed nav-link" data-target="#toggleFNS" data-toggle="collapse"
                       href="javascript:void(0);">
                        <i class="fas fa-hand-holding-usd"></i> Financial Services
                        <span aria-hidden="true" class="fa fa-caret-down float-right"></span>
                    </a>
                    <div class="collapse" id="toggleFNS" style="height: 0px;">
                        <RouterLink :to="{name:'NetworkIDTs'}" class="nav-link">
                            <i class="fas fa-fw"></i>Network IDTs
                        </RouterLink>
                    </div>
                    <div class="collapse" id="toggleFNS" style="height: 0px;">
                        <RouterLink :to="{name:'LeasingIDTs'}" class="nav-link">
                            <i class="fas fa-fw"></i>Leasing IDTs
                        </RouterLink>
                    </div>
                    <div class="collapse" id="toggleFNS" style="height: 0px;">
                        <RouterLink :to="{name:'ComputerAssets'}" class="nav-link">
                            <i class="fas fa-fw"></i> Computer Assets
                        </RouterLink>
                    </div>
                    <div class="collapse" id="toggleFNS" style="height: 0px;">
                        <RouterLink :to="{name:'ComputerLeases'}" class="nav-link">
                            <i class="fas fa-fw"></i> Computer Leases
                        </RouterLink>
                    </div>
                </li>
                <li class="nav-item"
                    v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator, ApplicationRole.HR)">
                    <a class="collapsed nav-link" data-target="#toggleHR" data-toggle="collapse"
                       href="javascript:void(0);">
                        <i class="fas fa-hand-holding"></i> Human Resources
                        <span aria-hidden="true" class="fa fa-caret-down float-right"></span>
                    </a>
                    <div class="collapse" id="toggleHR" style="height: 0px;">
                        <RouterLink :to="{name:'VISAs'}" class="nav-link">
                            <i class="fas fa-fw"></i>VISAs
                        </RouterLink>
                    </div>
                </li>
                <li class="nav-item"
                    v-if="hasApplicationRole(ApplicationRole.Management) && !hasApplicationRole(ApplicationRole.DatabaseAdministrator, ApplicationRole.HR)">
                    <RouterLink :to="{name:'VISAs'}" class="nav-link">
                        <i class="fa-id-card fas"></i>VISAs
                    </RouterLink>
                </li>
                <li class="nav-item" v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator)">
                    <a class="collapsed nav-link" data-target="#toggleOracle" data-toggle="collapse"
                       href="javascript:void(0);">
                        <i class="fas fa-database"></i> Oracle
                        <span aria-hidden="true" class="fa fa-caret-down float-right"></span>
                    </a>
                    <div class="collapse" id="toggleOracle" style="height: 0px;">
                        <RouterLink :to="{name:'OracleAccounts'}" class="nav-link">
                            <i aria-hidden="true" class="fas fa-fw"></i>Accounts
                        </RouterLink>
                        <RouterLink :to="{name:'OracleModuleRoles'}" class="nav-link">
                            <i aria-hidden="true" class="fas fa-fw"></i>Roles
                        </RouterLink>
                    </div>
                </li>
                <li class="nav-item">
                    <a href="javascript:void(0)" class="nav-link" @click.prevent="logout">
                        <i aria-hidden="true" class="fas fa-sign-out-alt"></i>Logout</a>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
import {Configuration} from "@/Configuration";
import {ApplicationRole} from "@/services/models/Role";
import AuthenticationService from "@/services/AuthenticationService";
    export default {
        data() {
            return {
                ApplicationRole: ApplicationRole,
            }
        },
        computed: {
            hideFinancialServicesFeature() {
                return Configuration.FeatureToggle.FinancialServices === 'true';
            }
        },
        methods:{
            logout(){
             AuthenticationService.logout();
            }
        }
    }
</script>

<style scoped>
    .navbar-side-navbar .nav-link {
        border-bottom: 1px solid #c9c9c9;
        color: #333;
        font-weight: 500;
        padding-left: 10px;
        padding-right: 10px;
    }

    .navbar-side-navbar .nav-link.active {
        color: #007bff;
    }

    .navbar-side-navbar .nav-item a:hover,
    .navbar-side-navbar .sidebar-navbar-collapse .navbar-nav a.active,
    .navbar-side-navbar .nav-item ul .nav-item a:hover,
    .navbar-side-navbar .nav-item ul .nav-item.active > a {
        background-color: #7f7f7f !important;
        color: white !important;
    }

    .navbar-side-navbar {
        padding: 0;
    }

    .navbar-side-navbar .navbar-header {
        padding: 10px 15px;
    }

    .navbar-side-navbar .navbar-nav {
        width: 100%;
    }

    .nav-link > i {
        margin-right: 10px;
    }

</style>
